// extracted by mini-css-extract-plugin
export default {"subtext":"newMailNotifier_subtext__0mp4J","stripes-animation-background-keyframes":"newMailNotifier_stripes-animation-background-keyframes__SKN6F"};